// extracted by mini-css-extract-plugin
export var border = "_1q-8";
export var brand = "_1q-t";
export var button = "_1q-l";
export var center = "_1q-a";
export var centered = "_1q-6";
export var closeButton = "_1q-c";
export var disabledWrapper = "_1q-m";
export var error = "_1q-p";
export var extraLarge = "_1q-4";
export var extraSmall = "_1q-1";
export var fill = "_1q-i";
export var footer = "_1q-h";
export var footerAction = "_1q-j";
export var footerButtons = "_1q-k";
export var header = "_1q-7";
export var headerWithClose = "_1q-d";
export var icon = "_1q-o";
export var info = "_1q-s";
export var inline = "_1q-9";
export var large = "_1q-3";
export var main = "_1q-e";
export var modal = "_1q-0";
export var nearFull = "_1q-5";
export var neutral = "_1q-u";
export var noPadding = "_1q-g";
export var none = "_1q-v";
export var scrollable = "_1q-f";
export var small = "_1q-2";
export var success = "_1q-r";
export var tight = "_1q-n";
export var titleIcon = "_1q-b";
export var warn = "_1q-q";